import styled from 'styled-components';

import { typographyV2 } from '~/design-tokens/typography/Typography.styles';

export const Container = styled.div`
  width: 100%;
  height: 100%;
`;

export const Text = styled.span<{ $useDash: boolean }>`
  ${({ $useDash }) => ($useDash ? typographyV2.uiSm : typographyV2.uiXs)};
  color: ${({ $useDash }) =>
    $useDash ? 'var(--text-soft)' : 'var(--text-disabled)'};
  font-family: ${({ $useDash }) =>
    $useDash ? 'var(--font-roboto)' : 'var(--font-nort)'};
`;
